import React, { Fragment, useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withTheme } from "styled-components";

import { Button, Checkbox } from "@pearsontechnology/aero-components";
import { ModalContent, ModalActions } from "components/Modal";
import { intl } from "containers/LanguageProvider/IntlGlobalProvider";

import { FormField, CheckBoxContainer, Italic } from "./styles";

import messages from "./messages";
import { cohortCheckboxesName } from "../constants";

import publicationService from "services/PublicationService";

function LockPluginVersionModal({ onDeploy, onDismiss, cohortId, deploymentId, deploymentDetails = {} }) {
  const [checkboxValues, setCheckBoxValues] = useState({
    lockPluginVersion: true,
    supportOnDemandEnabled: false,
    scorable: deploymentDetails?.isScored ? true : false,
    forceUpdateAssessments: false,
  });

  const onDemandCheckboxDisabled = deploymentId ? true : false;

  const handleCheckBoxChange = (event) => {
    const { name, checked } = event.target;
    setCheckBoxValues((preValues) => ({ ...preValues, [name]: checked }));
  };

  const isOnDemandCallback = useCallback(async (cohortId, deploymentId) => {
    const response = await publicationService.getIsOnDemand(
      cohortId,
      deploymentId
    );

    setCheckBoxValues((val) => ({
      ...val,
      supportOnDemandEnabled: response?.isOnDemand ? true : false,
    }));
  }, []);

  useEffect(() => {
    if (cohortId && deploymentId) {
      isOnDemandCallback(cohortId, deploymentId);
    }
  }, [cohortId, deploymentId, isOnDemandCallback]);

  return (
    <Fragment>
      <ModalContent>
        <FormField>
          <CheckBoxContainer>
            <Checkbox
              label={intl.formatMessage(
                messages.lockPluginVersionCheckboxLabel
              )}
              name={cohortCheckboxesName.LOCKDOWN_PLUGIN_VERSION}
              checked={checkboxValues.lockPluginVersion}
              value={"plugin"}
              onChange={handleCheckBoxChange}
            />
            <p>{intl.formatMessage(messages.lockPluginVersionDescription)}</p>
            <Italic>
              {intl.formatMessage(messages.lockPluginVersionDescriptionItalic)}
            </Italic>
          </CheckBoxContainer>
          <CheckBoxContainer>
            <Checkbox
              label={intl.formatMessage(
                messages.supportOnDemandClassesCheckboxLabel
              )}
              name={cohortCheckboxesName.SUPPORT_ON_DEMAND_CLASSES}
              checked={checkboxValues.supportOnDemandEnabled}
              onChange={handleCheckBoxChange}
              disabled={onDemandCheckboxDisabled}
            />
          </CheckBoxContainer>
          <CheckBoxContainer>
            <Checkbox
              label={intl.formatMessage(
                messages.scorable
              )}
              name={cohortCheckboxesName.SCORABLE}
              checked={checkboxValues.scorable}
              onChange={handleCheckBoxChange}
              disabled={deploymentDetails.isScored? onDemandCheckboxDisabled : !checkboxValues.supportOnDemandEnabled}
            />
            <Italic>
              {intl.formatMessage(messages.scorableDescriptionItalic)}
            </Italic>
          </CheckBoxContainer>
          <CheckBoxContainer>
            <Checkbox
              label={intl.formatMessage(
                messages.forceUpdateAssessments
              )}
              name={cohortCheckboxesName.FORCE_UPDATE_ASSESSMENTS}
              checked={checkboxValues.forceUpdateAssessments}
              onChange={handleCheckBoxChange}
              disabled={!checkboxValues.supportOnDemandEnabled}
            />
            <Italic>
              {intl.formatMessage(messages.forceUpdateAssessmentsDescriptionItalic)}
            </Italic>
          </CheckBoxContainer>
        </FormField>
      </ModalContent>
      <ModalActions scrim>
        <Button grey onClick={onDismiss}>
          {intl.formatMessage(messages.cancelButton)}
        </Button>
        <Button primary onClick={() => onDeploy(checkboxValues)}>
          {intl.formatMessage(messages.deployButton)}
        </Button>
      </ModalActions>
    </Fragment>
  );
}

LockPluginVersionModal.propTypes = {
  onDeploy: PropTypes.func,
  onDismiss: PropTypes.func,
  cohortId: PropTypes.string,
  deploymentId: PropTypes.string,
};

export default withTheme(LockPluginVersionModal);
